import { NuxtApp } from "#app";
import {
  Configuration,
  ContactControllerApi,
  CustomerControllerApi,
  OrderControllerApi,
  ProductControllerApi,
  RegistrationControllerApi,
  VoucherControllerApi,
  OrganisationControllerApi,
  TermsConditionsControllerApi,
  InvoicesControllerApi,
  DatabaseControllerApi,
  InfoControllerApi,
  DatabaseTemplateControllerApi,
  DatabaseAdminControllerApi,
  MessageControllerApi,
  CartControllerApi,
  SubscriptionControllerApi,
  AccountControllerApi,
  DatabaseSpecialOpsControllerApi,
  PurchaseHistoryControllerApi, SmtpControllerApi,
} from '~/api-client';

export class BackendService {
  private readonly _accountControllerApi: AccountControllerApi;
  private readonly _productControllerApi: ProductControllerApi;
  private readonly _customerControllerApi: CustomerControllerApi;
  private readonly _smtpControllerApi: SmtpControllerApi;
  private readonly _orderControllerApi: OrderControllerApi;
  private readonly _contactControllerApi: ContactControllerApi;
  private readonly _registrationControllerApi: RegistrationControllerApi;
  private readonly _voucherControllerApi: VoucherControllerApi;
  private readonly _organisationControllerApi: OrganisationControllerApi;
  private readonly _termsConditionsControllerApi: TermsConditionsControllerApi;
  private readonly _invoiceControllerApi: InvoicesControllerApi;
  private readonly _messageControllerApi: MessageControllerApi;
  private readonly _infoControllerApi: InfoControllerApi;
  private readonly _cartControllerApi: CartControllerApi;
  private readonly _subscriptionControllerApi: SubscriptionControllerApi;
  private readonly _purchaseHistoryControllerApi: PurchaseHistoryControllerApi;
  
  private readonly _databaseControllerApi: DatabaseControllerApi;
  private readonly _databaseTemplateControllerApi: DatabaseTemplateControllerApi;
  private readonly _databaseAdminControllerApi: DatabaseAdminControllerApi;
  private readonly _databaseSpecialOpsControllerApi: DatabaseSpecialOpsControllerApi;

  constructor(nuxt: NuxtApp) {
    const config = new Configuration({
      basePath: nuxt.$config.public.basePath,
      accessToken: (_) => {
        if (import.meta.client) {
          const userSession = useAuth();
          if (userSession.data.value) {
            // console.log("access token backend: " +  (<any>userSession.data.value).accessToken );
            return (<any>userSession.data.value).accessToken;
          } 
        } else {
          const authBasePath = nuxt.$config.public.auth.basePath;
          const headers = nuxt.ssrContext?.event.headers;
          return $fetch(`${authBasePath}/session`, {
            headers
          }).then((value) => (value as any).accessToken);
        }
      }
    });
    this._accountControllerApi = new AccountControllerApi(config);
    this._productControllerApi = new ProductControllerApi(config);
    this._customerControllerApi = new CustomerControllerApi(config);
    this._smtpControllerApi = new SmtpControllerApi(config);
    this._orderControllerApi = new OrderControllerApi(config);
    this._contactControllerApi = new ContactControllerApi(config);
    this._registrationControllerApi = new RegistrationControllerApi(config);
    this._voucherControllerApi = new VoucherControllerApi(config);
    this._organisationControllerApi = new OrganisationControllerApi(config);
    this._termsConditionsControllerApi = new TermsConditionsControllerApi(config);
    this._invoiceControllerApi = new InvoicesControllerApi(config);
    this._infoControllerApi = new InfoControllerApi(config);
    this._messageControllerApi = new MessageControllerApi(config);
    this._cartControllerApi = new CartControllerApi(config);
    this._subscriptionControllerApi = new SubscriptionControllerApi(config)
    this._purchaseHistoryControllerApi = new PurchaseHistoryControllerApi(config);

    this._databaseControllerApi = new DatabaseControllerApi(config);
    this._databaseTemplateControllerApi = new DatabaseTemplateControllerApi(config);
    this._databaseAdminControllerApi = new DatabaseAdminControllerApi(config);
    this._databaseSpecialOpsControllerApi = new DatabaseSpecialOpsControllerApi(config);
  }

  get accountControllerApi(): AccountControllerApi {
    return this._accountControllerApi;
  }
  get productControllerApi(): ProductControllerApi {
    return this._productControllerApi;
  }

  get messageControllerApi(): MessageControllerApi {
    return this._messageControllerApi;
  }

  get cartControllerApi(): CartControllerApi {
    return this._cartControllerApi;
  }

  get customerControllerApi(): CustomerControllerApi {
    return this._customerControllerApi;
  }

  get smtpControllerApi(): SmtpControllerApi {
    return this._smtpControllerApi;
  }

  get orderControllerApi(): OrderControllerApi {
    return this._orderControllerApi;
  }

  get contactControllerApi(): ContactControllerApi {
    return this._contactControllerApi;
  }

  get registrationControllerApi(): RegistrationControllerApi {
    return this._registrationControllerApi;
  }

  get subscriptionControllerApi(): SubscriptionControllerApi {
    return this._subscriptionControllerApi;
  }

  get purchaseHistoryControllerApi(): PurchaseHistoryControllerApi {
    return this._purchaseHistoryControllerApi;
  }

  get voucherControllerApi(): VoucherControllerApi {
    return this._voucherControllerApi;
  }

  get organisationControllerApi(): OrganisationControllerApi {
    return this._organisationControllerApi;
  }

  get termsConditionsControllerApi(): TermsConditionsControllerApi {
    return this._termsConditionsControllerApi;
  }

  get invoiceControllerApi(): InvoicesControllerApi {
    return this._invoiceControllerApi;
  }

  get databaseControllerApi(): DatabaseControllerApi {
    return this._databaseControllerApi;
  }

  get databaseTemplateControllerApi(): DatabaseTemplateControllerApi {
    return this._databaseTemplateControllerApi;
  }

  get infoControllerApi(): InfoControllerApi {
    return this._infoControllerApi;
  }

  get databaseAdminControllerApi(): DatabaseAdminControllerApi {
    return this._databaseAdminControllerApi;
  }

  get databaseSpecialOpsControllerApi(): DatabaseSpecialOpsControllerApi {
    return this._databaseSpecialOpsControllerApi;
  }
}
